// Invitations de coachs recues par l'athlete : tant qu'il ne l'a pas
// acceptee, le coach n'a pas acces a son calendrier (RoleService.accepterInvitation).
import * as React from 'react';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

import { accepterInvitation, refuserInvitation, type InvitationCoach } from './moi.ts';

export default function InvitationsCoach({ invitations }: { invitations: InvitationCoach[] }) {
  // Plus tard : la fenetre reviendra a la prochaine connexion.
  const [plusTard, setPlusTard] = React.useState(false);
  const [enCours, setEnCours] = React.useState(false);
  const [erreur, setErreur] = React.useState<string | null>(null);
  const invitation = invitations[0];

  const repondre = async (action: (id: string) => Promise<unknown>) => {
    setEnCours(true);
    setErreur(null);
    try {
      await action(invitation.id);
    } catch (e) {
      setErreur((e as Error).message);
    } finally {
      setEnCours(false);
    }
  };

  if (!invitation || plusTard) return null;
  const coach = invitation.coach || 'Un coach';

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <DialogTitle>Invitation d'un coach</DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 2 }}>
          <b>{coach}</b> te propose de te suivre comme coach.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Si tu acceptes, il pourra consulter et établir ton calendrier d'entraînement, et voir ta VMA et tes allures.
          Tu pourras le quitter à tout moment depuis la page Mes préférences.
        </Typography>
        {invitations.length > 1 && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Tu as {invitations.length} invitations : accepter celle-ci supprime les autres.
          </Typography>
        )}
        {erreur && <Alert severity="error" sx={{ mt: 2 }}>{erreur}</Alert>}
      </DialogContent>
      <DialogActions>
        <Button color="inherit" onClick={() => setPlusTard(true)} disabled={enCours}>Plus tard</Button>
        <Button color="error" onClick={() => repondre(refuserInvitation)} disabled={enCours}>Refuser</Button>
        <Button variant="contained" onClick={() => repondre(accepterInvitation)} disabled={enCours}>Accepter</Button>
      </DialogActions>
    </Dialog>
  );
}
